export const borderOptions = {
  'rounded-6': '6px',
  'rounded-8': '8px',
  'rounded-10': '10px',
  'rounded-12': '12px',
  'rounded-14': '14px',
  'rounded-16': '16px',
  'rounded-18': '18px',
  'rounded-9999': '9999px',

  'width-1': '1px',
  'width-1.5': '1.5px',
  'width-2': '2px'
}
